import { render, staticRenderFns } from "./MotorPermStatus.vue?vue&type=template&id=1ca57e30&"
import script from "./MotorPermStatus.vue?vue&type=script&lang=js&"
export * from "./MotorPermStatus.vue?vue&type=script&lang=js&"
import style0 from "./MotorPermStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MotorPermStatus.vue"
export default component.exports